module.exports = __webpack_public_path__ + "static/order-background-162b35e0fefe7d6f53f6b150937c5688.png";